import { SelectedFacet, SelectedFacetValuesByCode } from '../facets/interfaces';
import { AppRouterInstance } from '@spa/lib/router/AppRouterInstance';
import { ReadonlyURLSearchParams } from 'next/navigation';
import serializePath from '@spa/lib/router/serializePath';

export default function updateSelectedFacetsQuery(
  newSelectedFacets: Array<SelectedFacet>,
  router: AppRouterInstance,
  pathname: string,
  searchParams: ReadonlyURLSearchParams | URLSearchParams
): void {
  const newParams: SelectedFacetValuesByCode = newSelectedFacets.reduce((params, facet) => {
    if (facet.type !== 'range' && facet.values.length > 0) {
      params[facet.code] = facet.values.map((value) => value.code);
    } else if (facet.type === 'range') {
      params[facet.code] = [String(facet.from), String(facet.to)];
    }
    return params;
  }, {} as SelectedFacetValuesByCode);

  const updatedQuery = new URLSearchParams(searchParams);
  updatedQuery.delete('page');

  if (Object.keys(newParams).length === 0) {
    updatedQuery.delete('filterBy');
  } else {
    updatedQuery.set('filterBy', JSON.stringify(newParams));
  }

  void router.push(serializePath(pathname, updatedQuery));
}
